// i18n setup. PRD-00 D-15: react-i18next, namespace-based, lazy-loaded.
// Error-keys uit documentation/i18n-stubs/<locale>/errors.json — gekopieerd naar
// /public/locales/<locale>/errors.json bij build (zie scripts/copy-i18n.ts of vite-plugin).
//
// MVP-talen (PRD-00 §7.5): nl, en, ar (RTL), tr.

import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

export const SUPPORTED_LOCALES = ["nl", "en", "ar", "tr"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const RTL_LOCALES: Locale[] = ["ar"];

const SAVED_LOCALE_KEY = "bb:locale";

export function getSavedLocale(): Locale {
  const saved = localStorage.getItem(SAVED_LOCALE_KEY);
  if (saved && (SUPPORTED_LOCALES as readonly string[]).includes(saved)) {
    return saved as Locale;
  }
  // Detecteer via browser
  const browser = navigator.language.slice(0, 2);
  if ((SUPPORTED_LOCALES as readonly string[]).includes(browser)) {
    return browser as Locale;
  }
  return "nl";
}

export function setLocale(locale: Locale): void {
  localStorage.setItem(SAVED_LOCALE_KEY, locale);
  document.documentElement.lang = locale;
  document.documentElement.dir = RTL_LOCALES.includes(locale) ? "rtl" : "ltr";
  void i18n.changeLanguage(locale);
}

await i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getSavedLocale(),
    fallbackLng: "nl",
    supportedLngs: SUPPORTED_LOCALES,
    ns: ["common"],
    defaultNS: "common",
    nsSeparator: ":",
    keySeparator: ".",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

// Set initial document dir
const init = getSavedLocale();
document.documentElement.lang = init;
document.documentElement.dir = RTL_LOCALES.includes(init) ? "rtl" : "ltr";

export default i18n;
